import { z } from "zod";

/**
 * Zod reports a missing value as "Invalid input: expected string, received
 * undefined", and AutoForm renders `issue.message` verbatim — so that string
 * lands in the UI next to an empty field. AutoForm strips empty strings before
 * parsing, which is why a blank required field arrives as `invalid_type` with
 * an `undefined` input rather than failing the field's own `.min()`.
 *
 * `resolveMessage` runs at parse time, so a translated app resolves the message
 * in whatever language is active then rather than at registration.
 *
 * Call once during app start-up, before any schema is parsed.
 */
export const registerRequiredFieldErrorMap = (
  resolveMessage: () => string = () => "Required"
): void => {
  z.config({
    // Returning undefined lets Zod fall back to its own default message.
    customError: (issue) =>
      issue.code === "invalid_type" && issue.input === undefined
        ? resolveMessage()
        : undefined
  });
};
